import dayjs from "dayjs";
import { BASE_DEV_URL } from "./global-config";

export function formatThaiDate(timestamp) {
  const date = new Date(timestamp * 1000);
  const dateString = date.toLocaleDateString("th-TH", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  const timeString = date.toLocaleTimeString("th-TH", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  return `วันที่ ${dateString} เวลา ${timeString}`;
}

export function formatThaiDateShort(timestamp) {
  const date = new Date(timestamp * 1000);
  const dateString = date.toLocaleDateString("th-TH", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return dateString;
}

export function stringHtmlTags(str) {
  return (str ?? "")?.replace(/<[^>]*>/g, " ");
}

export const toImagePath = (path) => {
  const baseUrl = BASE_DEV_URL;

  let slicePath = path?.startsWith("/media/uploads") ? path.slice(14) : path;

  const category = "/media/uploads";

  if (window.location.hostname === "localhost") {
    return baseUrl + category + slicePath;
  }

  return category + slicePath;
};

export const toThaiDate = (date, format = "DD MMMM BBBB") => {
  return dayjs(new Date(date)).locale("th").format(format);
};

// export const toThaiDate = (date) => {
//   return new Date(date).toLocaleDateString("th-TH", {
//     year: "numeric",
//     month: "long",
//     day: "numeric",
//   });
// };

export function toPascalCase(str) {
  return str
    .replace(/(\w)(\w*)/g, function (_, firstChar, rest) {
      return firstChar.toUpperCase() + rest.toLowerCase();
    })
    .replace(/\s+/g, "");
}
